import type { CityLink } from '../types/onboarding'

/**
 * Seeded mirror of the "City Links" tab.
 *
 * The onboarding flow tries to read the live tab first (see
 * utils/tnsOnboarding.ts -> fetchCityLinks). If that read is unavailable —
 * for example before the Google Sheets integration is connected, or if the
 * Apps Script has no GET handler yet — the flow falls back to these rows so
 * the city dropdown is never empty and the WhatsApp routing still works.
 *
 * Keep these in sync with the sheet.
 */
export const tnsCityLinks: CityLink[] = [
  {
    city_id: 'BEN',
    city_name: 'Benin',
    whatsapp_link: 'https://chat.whatsapp.com/Gg0acDUlz9WKb1bu4EPeEf',
    active: true,
  },
  {
    city_id: 'LOS',
    city_name: 'Lagos',
    whatsapp_link: 'https://chat.whatsapp.com/BmhDckI1FiEJxVxNUXQbKh',
    active: true,
  },
  {
    city_id: 'ASB',
    city_name: 'Asaba',
    whatsapp_link: 'https://chat.whatsapp.com/DkaarUKWs7aJ6crRvDPOpt',
    active: true,
  },
  {
    city_id: 'UYO',
    city_name: 'Uyo',
    whatsapp_link: 'https://chat.whatsapp.com/IJAovNsQlYb0lqR9wGcBvL',
    active: true,
  },
  {
    city_id: 'ABJ',
    city_name: 'Abuja',
    whatsapp_link: 'https://chat.whatsapp.com/KyuLep5qjEwHU6VR8tiBW9',
    active: true,
  },
  {
    city_id: 'CAN',
    city_name: 'Canada',
    whatsapp_link: 'https://chat.whatsapp.com/EoH9cpC9aKf3UpVkypIJ8U',
    active: true,
  },
  {
    city_id: 'PHC',
    city_name: 'Port Harcourt',
    whatsapp_link:
      'https://chat.whatsapp.com/JFzBdGe9gT92ljvUSRqvhE?s=cl&p=a&ilr=4',
    active: true,
  },
  {
    city_id: 'WAR',
    city_name: 'Warri',
    whatsapp_link:
      'https://chat.whatsapp.com/H9pJfdO1GowB5bDvB0faDO?s=cl&p=a&ilr=4',
    active: true,
  },
  {
    city_id: 'CAL',
    city_name: 'Calabar',
    whatsapp_link:
      'https://chat.whatsapp.com/GYDOJwCedPS4uqQQas4gx4?s=cl&p=a&ilr=4',
    active: true,
  },
  {
    city_id: 'OTH',
    city_name: 'Other',
    whatsapp_link: '',
    active: true,
  },
]
